import * as React from "react"
import { Link } from "react-router-dom"
import { type Category, type EntityCategory } from "@digits-graphql/frontend/graphql-bearer"
import { svgPathStyles } from "@digits-shared/components/SVG/svgIconStyles"
import { type IconSize } from "@digits-shared/components/UI/Icons/Icon"
import colors from "@digits-shared/themes/colors"
import styled, { css } from "styled-components"
import { CATEGORY_COLOR_MAP } from "src/frontend/components/OS/Applications/CategoryManager/Shared"
import { useFrontendPathGenerator } from "src/frontend/hooks/useFrontendPathGenerator"
import routes from "src/frontend/routes"
import { SVGIconComponent } from "src/shared/components/Icons/SVGIcon"

const IconBackground = styled(Link)<{ color?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  min-width: 80px;
  height: 80px;
  border-radius: 4px;
  background: ${({ color }) => color || colors.secondary};
`

const Icon = styled(SVGIconComponent)`
  width: 40px;
  height: 40px;
  ${svgPathStyles(colors.white, 1.5)};
`

// The default trigger for the CategoryHover
export const CategoryHoverIcon = styled(SVGIconComponent)<{ color?: string; size: IconSize }>`
  padding: 2px;
  ${({ color }) => svgPathStyles(color ?? colors.secondary, 1.5)};
  ${({ size }) => css`
    width: ${size.pixels}px;
    height: ${size.pixels}px;
    min-height: ${size.pixels}px;
  `};
`

// The category icon within the CategoryHover
export const CategoryIcon: React.FC<{
  category: Category | EntityCategory
  className?: string
}> = ({ category, className }) => {
  const generatePath = useFrontendPathGenerator()
  const { type, displayKey, active, id } = category

  return (
    <IconBackground
      to={generatePath(routes.categoryDetails, { categoryId: id })}
      color={active ? CATEGORY_COLOR_MAP.get(type) : colors.secondary50}
      className={className}
    >
      <Icon subjectDisplayKey={displayKey} />
    </IconBackground>
  )
}
